import React from 'react'

export default function IntroSection(props) {
  
  return (
    <section className="introSection">
      <header>
        <h2>Introduction</h2>
      </header>
      <p>
        Thank you for taking the time to read this.
        I am attempting to change careers.
        I've been an accountant (CPA) for the last 12 years.
        My favorite part of being an accountant was to play with VBA and Excel.
        I love coding, and I am willing to put in the work. I just need a chance.
      </p>
    </section>
  )
}